import { arrayContains } from 'utils';
import { GET_USER_PAYMENT_INFOS_REQUEST } from 'redux/actions/payment';

export const isUserPaymentInformationLoading = (state) => arrayContains(state.payment.openRequests, [GET_USER_PAYMENT_INFOS_REQUEST]);
